import { __assign } from "tslib";
var summaryHelper = /** @class */ (function () {
    function summaryHelper(storageApi, instanceId) {
        this.storageApi = storageApi;
        this.ITEMS_SUMMARY_KEY = "".concat(instanceId, "_summary");
        this.itemsSummary = null;
    }
    summaryHelper.prototype.getItemsSummary = function () {
        if (this.itemsSummary) {
            return this.itemsSummary;
        }
        else {
            var itemSummaryFromStorage = this.getItemsSummaryFromStorage();
            if (itemSummaryFromStorage) {
                this.itemsSummary = itemSummaryFromStorage;
                return itemSummaryFromStorage;
            }
            else {
                // No items summary available - create empty items summary
                this.setItemsSummaryInStorage({});
                return this.getItemsSummary();
            }
        }
    };
    summaryHelper.prototype.addItemToSummary = function (item) {
        var _a;
        var summary = this.getItemsSummary();
        var newSummary = __assign(__assign({}, summary), (_a = {}, _a[item.uuid] = item.quantity, _a));
        return this.setItemsSummary(newSummary);
    };
    summaryHelper.prototype.removeItemFromSummary = function (item) {
        var summary = this.getItemsSummary();
        var newSummary = __assign({}, summary);
        delete newSummary[item.uuid];
        return this.setItemsSummary(newSummary);
    };
    summaryHelper.prototype.updateCartItemInSummary = function (item) {
        var _a;
        var summary = this.getItemsSummary();
        var quantity = item.quantity;
        if (quantity && summary[item.uuid] !== quantity) {
            return this.setItemsSummary(__assign(__assign({}, summary), (_a = {}, _a[item.uuid] = item.quantity, _a)));
        }
        return summary;
    };
    summaryHelper.prototype.setItemsSummary = function (summary) {
        this.setItemsSummaryInStorage(summary);
        this.itemsSummary = summary;
        return summary;
    };
    summaryHelper.prototype.getItemsSummaryFromStorage = function () {
        var jsonSummary = this.storageApi.getItem(this.ITEMS_SUMMARY_KEY);
        return jsonSummary && JSON.parse(jsonSummary);
    };
    summaryHelper.prototype.clearItemsSummaryInStorage = function () {
        this.storageApi.removeItem(this.ITEMS_SUMMARY_KEY);
        this.storageApi.clear(this.ITEMS_SUMMARY_KEY);
    };
    summaryHelper.prototype.setItemsSummaryInStorage = function (summary) {
        this.storageApi.setItem(this.ITEMS_SUMMARY_KEY, JSON.stringify(summary));
    };
    summaryHelper.prototype.clear = function () {
        this.clearItemsSummaryInStorage();
        this.itemsSummary = null;
    };
    return summaryHelper;
}());
export default summaryHelper;
//# sourceMappingURL=summaryHelper.js.map